function init() {
  function render(results) {
    var i, n;
    for (i = 0, n = output.length; i < n; i++) {
      var key = output[i].getAttribute("data-result");
      output[i].replaceChildren(
        Object.prototype.hasOwnProperty.call(results, key)
          ? results[key].toFixed(1)
          : ""
      );
    }
  }

  function displayError(msg) {
    var container = input.parentElement,
      err = container.querySelector(".usa-error-message");

    err.innerText = msg;
    container.setAttribute("class", "usa-form-group usa-form-group--error");
  }

  function clearError() {
    var container = input.parentElement,
      err = container.querySelector(".usa-error-message");

    err.innerText = "";
    container.setAttribute("class", "usa-form-group");
  }

  function onSubmit(e) {
    e.preventDefault();

    var results = {};

    results.ceilingFeet = Number.parseFloat(input.value);
    results.ceiling = results.ceilingFeet * 12;

    results.centerToCeiling = results.ceiling - CENTER_TO_FLOOR;
    results.topToCeiling = results.centerToCeiling - RADIUS;
    results.snapLine = Math.tan(ANGLE) * results.centerToCeiling;
    results.triangleEdge = results.snapLine * Math.sqrt(3);
    results.triangleEdgeHalf = results.triangleEdge / 2;
    results.snapLineHalf =
      Math.sqrt(
        Math.pow(results.triangleEdge, 2) -
          Math.pow(results.triangleEdgeHalf, 2)
      ) - results.snapLine;

    var isTooSmall = Object.keys(results).some(function (k) {
      return results[k] <= 0;
    });

    if (isTooSmall) {
      displayError("Ceiling Height is too small");
    } else {
      clearError();
    }

    render(results);
  }

  // Constants for a typical Sphere setup. All distances in inches, angles in
  // radians.
  var DIAMETER = 68,
    RADIUS = DIAMETER / 2,
    BOTTOM_TO_FLOOR = 52,
    CENTER_TO_FLOOR = BOTTOM_TO_FLOOR + RADIUS,
    ANGLE = (20 * Math.PI) / 180;

  var form = document.getElementById("sphere-mount-calculator");
  var input = document.getElementById("ceiling-height");
  var output = document.querySelectorAll("[data-result]");

  form.addEventListener("submit", onSubmit);
  form.removeAttribute("x-cloak");
}

if (typeof document.querySelector === "function") {
  window.addEventListener("load", init);
}
